import type { Preco, TabelaPreco } from '../db/tipos'

export interface PrecoDeTabela {
  tabela: string
  preco: number
}

// As mesmas exclusoes da busca dentro do pedido (`pedidos/buscaPrecos.ts`), e
// pelo mesmo motivo: a tela de Produtos nao pode mostrar um preco que o pedido
// depois recusa. Preco que aparece num lugar e some no outro ja e uma classe de
// erro conhecida aqui.
export function precosPorProduto(
  tabelas: readonly TabelaPreco[],
  precos: readonly Preco[],
): Map<string, PrecoDeTabela[]> {
  const nomePorTabela = new Map(
    tabelas.filter((t) => t.apagado_em === null && t.ativa).map((t) => [t.id, t.nome]),
  )

  const mapa = new Map<string, PrecoDeTabela[]>()
  for (const p of precos) {
    if (p.apagado_em !== null) continue
    const tabela = nomePorTabela.get(p.tabela_preco_id)
    if (tabela === undefined) continue
    const linhas = mapa.get(p.produto_id) ?? []
    linhas.push({ tabela, preco: p.preco })
    mapa.set(p.produto_id, linhas)
  }

  // Por NOME, nao pela ordem de chegada do banco: assim a mesma tabela cai
  // sempre na mesma posicao em todo cartao, e o olho acha sem precisar ler.
  for (const linhas of mapa.values()) {
    linhas.sort((a, b) => a.tabela.localeCompare(b.tabela, 'pt-BR'))
  }
  return mapa
}
